<form (ngSubmit)="save()">
	<section #rootElement class="billboard" tabindex="-1">
		<div class="billboard-header">
			<h2 class="billboard-title">Contact</h2>
			<div class="billboard-actions">
				<div class="btn-toolbar">
					<button
						class="btn btn-secondary"
						id="profile.contact.edit.cancel"
						type="button"
						(click)="contactSaveListener(false)"
					>
						Cancel
					</button>
					<button
						class="btn btn-primary"
						id="profile.contact.edit.enable"
						type="submit"
						[disabled]="
							savingInfo || !profileContactFormGroup?.valid || !hasChanges
						"
					>
						Save Changes
					</button>
				</div>
			</div>
		</div>
		<div class="billboard-body" [formGroup]="profileContactFormGroup">
			<!-- Phone Numbers -->
			@if (profileContactFormGroup?.controls.phone.enabled) {
				<div class="mb-3">
					<div class="d-flex align-items-end">
						<h3 class="flex-grow-1 fw-bold fs-5">
							Phone Numbers
							<ng-container
								*ngTemplateOutlet="
									requiresProof;
									context: {
										$implicit: proofMap.get('phone'),
									}
								"
							/>
						</h3>
						<div class="text-end">
							<button
								class="btn btn-default"
								id="profile.contact.edit.phone.add"
								title="Add Phone Number"
								type="button"
								(click)="addPhone()"
							>
								Add Phone
							</button>
						</div>
					</div>
					<div class="form-group">
						@if (profileContactFormGroup?.controls.phone.length > 0) {
							@for (
								item of profileContactFormGroup?.controls.phone.controls;
								track item;
								let i = $index;
								let last = $last
							) {
								<div class="mb-3" formArrayName="phone">
									<div class="row" [formGroupName]="i">

										<!-- Number -->
										<div aeGroupValidation class="form-group col-md-6 col-xl-4">
											<ae-form-label
												for="profile.contact.edit.phone.{{ i }}.phone"
												label="Number"
												required
											/>
											<input
												autocomplete="tel"
												class="form-control"
												formControlName="phone"
												id="profile.contact.edit.phone.{{ i }}.phone"
												required
												type="tel"
											/>
											<ae-group-validation-display [maxDisplay]="1">
												<ng-template aeValidationError="notsevendigitphone">
													Must be a 10 digit phone number
												</ng-template>
												<ng-template aeValidationError="phone">
													Must be a phone number
												</ng-template>
												<ng-template aeValidationError="required">
													No empty phone inputs
												</ng-template>
											</ae-group-validation-display>
										</div>
										<div class="form-group col-6 col-md-3 col-xl-2">
											<label for="profile.contact.edit.phone.{{ i }}.type">
												Type
											</label>
											<select
												class="form-select"
												formControlName="type"
												id="profile.contact.edit.phone.{{ i }}.type"
											>
												<option selected="true" value=""></option>
												@for (type of phoneOptions | keyvalue; track type) {
													<option [value]="type.key">
														{{ type.value }}
													</option>
												}
											</select>
										</div>
										<div class="form-group col-6 col-md-3 col-xl-2">
											<div class="d-block label-spacer">&nbsp;</div>
											<ae-input-checkbox
												formControlName="sms"
												id="profile.contact.edit.phone.{{ i }}.sms"
											>
												SMS Capable
											</ae-input-checkbox>
										</div>
									</div>
									<div class="row">
										<div class="col-xl-8 d-flex">
											<div class="flex-grow-1">
												<label>
													<input
														class="screen-reader-text"
														title="{{
															i === primaryPhoneIndex
																? 'Primary Phone'
																: 'Set as Primary Phone'
														}}"
														type="checkbox"
														[disabled]="savingInfo"
														(click)="setPrimaryPhone(i)"
													/>
													@switch (i === primaryPhoneIndex) {
														@case (true) {
															<i
																aria-hidden="true"
																class="fas fa-check-square pointer"
															></i>
														}
														@default {
															<i
																aria-hidden="true"
																class="far fa-square pointer"
															></i>
														}
													}
													<span class="unselectable pointer"> Primary </span>
												</label>
											</div>
											<button
												class="btn btn-default"
												id="profile.contact.edit.phone.{{ i }}.delete"
												title="Remove Phone Number"
												type="button"
												[attr.aria-label]="'Remove Phone Number' + i"
												[disabled]="savingInfo"
												(click)="deletePhone(i)"
											>
												Remove
											</button>
										</div>
									</div>
								</div>
							}
						} @else {
							<div class="text-muted">No Phones</div>
						}
					</div>
				</div>
			}

			<!-- Emails -->
			<div class="mb-3">
				<h3 class="fw-bold fs-5">Email Address</h3>
				<div class="text-muted">Edited in Security Tab</div>
			</div>

			<!-- SSO Emails -->
			@if (profileContactFormGroup?.controls.ssoEmail.length > 0) {
				<div class="mb-3">
					<h3 class="fw-bold fs-5">SSO Email Address</h3>
					@for (
						fg of profileContactFormGroup?.controls.ssoEmail.controls;
						track fg;
						let i = $index;
						let last = $last
					) {
						<div class="d-flex flex-nowrap mb-1">
							<div aeGroupValidation class="flex-grow-1 me-1">
								<input
									autocomplete="off"
									class="form-control"
									id="profile.contact.edit.ssoEmail.{{ i }}"
									placeholder="Street"
									type="text"
									[formControl]="fg.controls.newValue"
								/>
								<ae-group-validation-display [maxDisplay]="1">
									<ng-template aeValidationError="email" let-error>
										{{ error }}
									</ng-template>
									<ng-template
										aeValidationError="protectedEmailRequired"
										let-error
									>
										{{ error }}
									</ng-template>
								</ae-group-validation-display>
							</div>
							@if (canEditSSOEmail) {
								<ng-template #ssoEmailDelete>
									{{ getSsoEmailDeleteTitle(fg) }}
								</ng-template>
								<div triggers="hover" [ngbTooltip]="ssoEmailDelete">
									<button
										class="btn btn-icon"
										id="profile.contact.edit.ssoEmail.{{ i }}.delete"
										type="button"
										[disabled]="fg.controls.delete.disabled"
										(click)="
											fg.controls.delete.setValue(!fg.controls.delete.value)
										"
									>
										<i
											aria-hidden="true"
											class="far fa-fw"
											[ngClass]="
												fg.controls.delete.value
													? 'fa-trash-can-undo'
													: ' fa-trash-can'
											"
										></i>
									</button>
								</div>
							}
						</div>
					}
				</div>
			}

			<!-- Physical Address -->
			@if (profileContactFormGroup?.controls.physical_address.enabled) {
				<div class="mb-3">
					<div class="d-flex align-items-end">
						<h3 class="flex-grow-1 fw-bold fs-5">
							Physical Address
							<ng-container
								*ngTemplateOutlet="
									requiresProof;
									context: {
										$implicit: proofMap.get('physical_address'),
									}
								"
							/>
						</h3>
					</div>

					<div class="mb-3">
						<ae-address-form
							[formGroup]="profileContactFormGroup?.controls.physical_address"
							[shortenRows]="true"
							[stateOptions]="
								contactOptions?.contact_field?.physical_address?.subfields
									?.address?.subfields?.state?.options
							"
						/>
					</div>
				</div>
			}

			<!-- Mailing Address -->
			<div class="mb-3">
				<div class="d-flex align-items-end">
					<h3 class="flex-grow-1 fw-bold fs-5">
						Mailing Address
						<ng-container
							*ngTemplateOutlet="
								requiresProof;
								context: {
									$implicit: proofMap.get('mailing_address'),
								}
							"
						/>
					</h3>
					<ae-input-checkbox
						id="lunchbox.pages.studentinfo.studentinfoform.mailing_address"
						type="toggle"
						[formControl]="toggleAddressCtrl"
					>
						Same As Physical
					</ae-input-checkbox>
				</div>

				<div class="mb-3">
					<ae-address-form
						[formGroup]="profileContactFormGroup?.controls.mailing_address"
						[shortenRows]="true"
						[stateOptions]="
							contactOptions?.contact_field?.mailing_address?.subfields?.address
								?.subfields?.state?.options
						"
					/>
				</div>
			</div>

			<!-- Calendar -->
			<div>
				<div class="d-flex align-items-end">
					<h3 class="flex-grow-1 fw-bold fs-5">
						Calendar Link
						<ae-icon-tooltip
							class="fs-normal"
							message="Full URL link used for Calendar apps like Calendly"
							type="help"
						/>
					</h3>
					@if (profileContactFormGroup?.controls.calendar.disabled) {
						<button
							class="btn btn-default"
							id="profile.contact.edit.calendar.add"
							title="Add Calendar Link"
							type="button"
							[disabled]="
								savingInfo || profileContactFormGroup?.controls.calendar.enabled
							"
							(click)="addCalendar()"
						>
							Add Link
						</button>
					}
				</div>
				<div>
					@if (profileContactFormGroup?.controls.calendar.enabled) {
						<div class="force-display-feedback mb-3">
							<div class="row">

								<!-- Link -->
								<div aeGroupValidation class="col-xl-6 form-group">
									<ae-form-label
										class="screen-reader-text"
										for="profile.contact.edit.calendar.link"
										label="Link"
										required
									/>
									<div>
										<div class="d-flex">
											<input
												autocomplete="off"
												class="form-control"
												formControlName="calendar"
												id="profile.contact.edit.calendar.link"
												placeholder="https://calendly.com/janedoe"
												required
												type="text"
											/>
											<div class="ms-1">
												<button
													class="btn btn-default"
													title="Remove Calendar Link"
													type="button"
													[attr.aria-label]="'Remove Calendar'"
													[disabled]="savingInfo"
													(click)="deleteCalendar()"
												>
													Remove
												</button>
											</div>
										</div>

										<ae-group-validation-display [maxDisplay]="1">
											<ng-template aeValidationError="required">
												Cannot have an empty link
											</ng-template>
											<ng-template aeValidationError="url">
												Must have a full and proper URL
											</ng-template>
										</ae-group-validation-display>
									</div>
								</div>
							</div>
						</div>
					} @else {
						<div class="text-muted">No Calendar Link</div>
					}
				</div>
			</div>
		</div>
	</section>
</form>

<ng-template #requiresProof let-item>
	@if (item?.required) {
		<i
			aria-hidden="true"
			class="fas fa-triangle-exclamation text-danger"
			ngbTooltip="This field requires proof to update. You will be asked to provide documentation when you save."
		></i>
	}
</ng-template>
